import CategoryType from 'owa-service/lib/contract/CategoryType';
import ColorScheme from 'mini-color-utils/lib/ColorScheme';
import { isNumber } from 'mini-common-utils/lib/utils/isNumber';
import {
    getDefaultCategoryColorScheme,
    getCategoriesColorSchemes,
} from './getCategoriesColorSchemes';

/**
 * Returns the color scheme for a given calendar
 * @param category
 */
export const getColorSchemeForCategory = (category: CategoryType): ColorScheme => {
    const colorScheme =
        category && isNumber(category.Color)
            ? getCategoriesColorSchemes()[category.Color.toString()]
            : null;
    return colorScheme || getDefaultCategoryColorScheme();
};
